import {mainColors} from "../../../../app.style";

export const appDropZoneStyle = {
  border: 1,
  borderRadius: "28px",
  borderStyle: "dashed",
  borderColor: mainColors.grey.color,
  width: "100%",
  textAlign: "center"
}